import React, { FC, useEffect } from 'react';

import { Fit, Layout, useRive } from '@rive-app/react-canvas';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import AnimationSrc from '~/modules/extension/assets/works_everywhere.riv';
import { onAssetLoad } from '~/utils/animations';

const getTexts = (t: TFunction): { runName: string; text: string }[] => {
  return [
    {
      runName: 'works_everywhere',
      text: t(
        'animations:extension_overview_page.works_everywhere',
        'Works everywhere you do',
      ),
    },
  ];
};

const WorksEverywhereAnimation: FC = () => {
  const { t } = useTranslation();

  const { rive, RiveComponent } = useRive({
    src: AnimationSrc,
    autoplay: true,
    layout: new Layout({
      fit: Fit.Cover,
    }),
    assetLoader: onAssetLoad,
  });

  useEffect(() => {
    if (rive) {
      [...getTexts(t)].forEach(({ runName, text }) => {
        rive.setTextRunValue(runName, text);
      });
    }
  }, [rive]);

  return <RiveComponent />;
};

export default WorksEverywhereAnimation;
